import React from 'react'
import formatDate from 'helpers/dateTimeFormatter'
import { numberColumn } from 'components/DataTableTest'
import numberFormatter from 'helpers/numberFormatter'

export const userList = t => [
	{
		Header: <span className='sort-icons'>{t('common.fields.code')}</span>,
		accessor: 'code',
		width: 90,
		Cell: ({ original, value }) => <span style={{ color: original?.isActive ? 'unset' : 'lightgray' }}>{value}</span>
	}, {
		Header: 'Name',
		accessor: 'name',
		Cell: ({ original, value }) => <span style={{ color: original?.isActive ? 'unset' : 'lightgray' }}>{value}</span>
	}
]

export const getLoyaltyCardBills = (t) => [
	{
		Header: t('common.fields.date'),
		accessor: 'date',
		searchable: false,
		Cell: ({ value }) => value ? value?.replace(/-/ig, '.')?.split('.')?.reverse()?.join('.') : ''
	},
	{
		Header: t('common.fields.time'),
		accessor: 'dateTime',
		searchable: false,
		Cell: ({ value }) => value ? formatDate(value, 'HH:mm:ss') : ''
	},
	{
		Header: t('common.fields.cash_register'),
		accessor: 'cashRegister.name',
		width: 120
	},
	{
		Header: t('user_section.fields.bill_number'),
		accessor: 'number',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	},
	{
		Header: t('user_section.fields.cancellation'),
		accessor: 'isCancelled',
		Cell: ({ value }) => value ? t('common.strings.canceled') : t('common.strings.not_canceled')
	},
	{
		Header: t('common.fields.total'),
		accessor: 'total',
		format: (options = {}) => numberColumn({ ...options, aggregateType: 'sum' })
	}
]

const StrickOutCellOnDelFlag = ({ flag }, displayValue) => {
	if(flag === 'Deleted') {
		return <div style={{ textDecoration: 'line-through' }}>{displayValue}</div>
	}
	return displayValue || ''
}

export const getLoyaltyCardItemBills = (t, locales) => [
	{
		Header: t('common.fields.quantity'),
		accessor: 'amount',
		format: (defaultOptions = {}) => numberColumn({ ...defaultOptions, toFixed: 0 }),
		Cell: ({ row: { original }, value }) => StrickOutCellOnDelFlag(original, value),
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('common.fields.code'),
		accessor: 'product.code',
		width: 80,
		Cell: ({ row: { original }, value }) => StrickOutCellOnDelFlag(original, value)
	}, {
		Header: t('common.fields.name'),
		accessor: 'product.name',
		width: 120,
		Cell: ({ row: { original }, value }) => {
			if(value) {
				return StrickOutCellOnDelFlag(original, value)
			}
			switch(original.flag) {
				case 'TotalAmount':
					return t('common.fields.total')
				case 'TotalInEuro':
					return `${t('closing_section.strings.billitem_given')} (€ ${numberFormatter(original.mul1, { locale: locales, toFixed: 2 })}) `
				case 'Retour':
					return t('user_section.strings.return')
				case 'TotalInCHF':
					return t('user_section.strings.given')
				default:
					return original.flag || ''
			}
		}
	}, {
		Header: t('common.fields.amount'),
		accessor: 'price',
		Cell: ({ row: { original }, value }) => original.flag === 'zero' ? value.toLocaleString(locales, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		},
		width: 50
	}, {
		Header: '%',
		accessor: 'discountPercent',
		width: 60,
		Cell: ({ row: { original }, value }) => original.discountPercent ? StrickOutCellOnDelFlag(original, `${value}%`) : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('common.strings.vat'),
		accessor: 'codeMWSt',
		Cell: ({ row: { original } }) => {
			switch(original.codeMWSt) {
				case 'free':
					return StrickOutCellOnDelFlag(original, t('user_section.fields.vat_free'))
				case 'normal':
					return StrickOutCellOnDelFlag(original, t('user_section.fields.vat_normal'))
				case 'reduced':
					return StrickOutCellOnDelFlag(original, t('user_section.fields.vat_reduced'))
				case 'special':
					return StrickOutCellOnDelFlag(original, t('user_section.fields.vat_special'))
				default:
					return StrickOutCellOnDelFlag(original, (original.codeMWSt || ''))
			}
		}
	}, {
		Header: t('statistic_section.strings.in_cafe'),
		accessor: 'inCafe',
		Cell: ({ row: { original }, value }) => original.flag === 'zero' ? StrickOutCellOnDelFlag(original, value) : true
	}, {
		Header: t('common.fields.total'),
		accessor: 'total',
		Cell: ({ row: { original }, value }) => value ? StrickOutCellOnDelFlag(original, value.toLocaleString(locales, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		})) : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}
]

export const getDiscountAllowance = (t, locales, month) => [
	{
		Header: t('common.dates.month'),
		accessor: 'month'
	},
	{
		Header: t('user_section.fields.based'),
		accessor: 'based',
		Cell: ({ value }) => value.toLocaleString(locales, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}),
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	},
	{
		Header: t('user_section.fields.balance'),
		accessor: 'balance',
		Cell: ({ value }) => typeof month === 'number' ? value.toLocaleString(locales, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : value,
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}
]
